
import config from '@/config';

export default {
  name: 'FileUploader',

  props: {
    label: {
      type: String,
      default: '',
    },
    task: {
      type: Object,
      default: (): Record<string, unknown> => ({}),
    },
    shouldClear: Boolean,
    picUpload: Boolean,
    mandatory: {
      type: Boolean,
      default: true,
    },
  },

  data(): Record<string, unknown> {
    return {
      file: '',
      pic: '',
      imageTooBig: false,
      fileTooBig: false,
      testFile: null,
      elementId: '',
    };
  },
  computed: {
    comesFromTrainings(): boolean {
      return (
        this.label === 'Task' || this.label === 'Post-Evaluation' || this.label === 'Pre-Evaluation'
      );
    },
  },

  watch: {
    shouldClear(): void {
      if (this.shouldClear) {
        if (this.label === 'Task') {
          this.clearTaskFile();
        } else if (this.label === 'Pre-Evaluation') {
          this.clearPreEvaluationFile();
        } else if (this.label === 'Post-Evaluation') {
          this.clearPostEvaluationFile();
        } else {
          this.clearFile();
        }
      }
    },
  },

  methods: {
    handleFileChange(
      elementId: string,
      eventToEmit: string,
      dataToPass: unknown,
      label: string,
    ): void {
      const selectedFile = (document.getElementById(elementId) as HTMLInputElement)?.files;
      const fileReader = new FileReader();
      let regex: RegExp;
      let fileToLoad: Blob;
      let base64: string | ArrayBuffer;
      this.elementId = elementId;
      if (selectedFile?.length) {
        fileToLoad = selectedFile?.[0];
      } else if (process.env.NODE_ENV === 'test') {
        fileToLoad = this.testFile;
      }

      if (!(fileToLoad instanceof Blob) && !config.isOnTestEnv) {
        return;
      }

      this.handleFileSize(fileToLoad, elementId);

      if (this.imageTooBig || this.fileTooBig) return;

      fileReader.readAsDataURL(fileToLoad);
      fileReader.onload = (fileLoadedEvent) => {
        base64 = fileLoadedEvent.target.result;

        if (
          elementId === 'fileUploader' ||
          elementId.startsWith('taskUploader') ||
          elementId === 'postEvaluationUploader' ||
          elementId === 'preEvaluationUploader'
        ) {
          regex = /data:application\/pdf;base64,/;
        } else {
          (base64 as string).slice(0, 23).includes('jpeg')
            ? (regex = /data:image\/jpeg;base64,/)
            : (regex = /data:image\/png;base64,/);
        }

        dataToPass = (base64 as string).replace(regex, '');
        this.$emit(eventToEmit, dataToPass, label);
      };
    },

    handleFileSize(fileToLoad: Blob, elementId: string): void {
      if (fileToLoad?.size >= config.MAX_IMAGE_SIZE && elementId === 'picUploader') {
        this.$message({
          showClose: true,
          message: this.$t('imageTooBig'),
          type: 'warning',
          duration: 5000,
        });

        this.imageTooBig = true;
      } else if (
        fileToLoad?.size >= config.MAX_FILE_SIZE &&
        (elementId === 'fileUploader' ||
          elementId.startsWith('taskUploader') ||
          elementId === 'preEvaluationUploader' ||
          elementId === 'postEvaluationUploader')
      ) {
        this.$message({
          showClose: true,
          message: this.$t('fileTooBig'),
          type: 'warning',
          duration: 5000,
        });

        this.fileTooBig = true;
      }
    },

    resetSizeTooBigErrors(): void {
      this.imageTooBig = false;
      this.fileTooBig = false;
    },

    adjustInputUI(querySelector: string, elementId: string): void {
      const uploadFailed: boolean =
        (document.getElementById(elementId) as HTMLInputElement).files[0] === undefined ||
        this.imageTooBig ||
        this.fileTooBig;

      if (uploadFailed) {
        this.resetSizeTooBigErrors();
        return;
      }

      this.displayFileName(querySelector, elementId);
      this.changeInputColors(elementId);
    },

    displayFileName(querySelector: string, elementId: string): void {
      this.imageTooBig = false;
      this.fileTooBig = false;

      document.querySelector(querySelector).textContent = (document.getElementById(
        elementId,
      ) as HTMLInputElement).files[0].name;
    },

    changeInputColors(elementId: string): void {
      if (!this.mandatory) return;

      document.getElementById(`${elementId}Label`).style.borderColor = '#2bc358';
      (document.getElementById(`${elementId}Label`).lastChild as HTMLElement).style.color =
        '#2bc358';
    },

    clearFile(): void {
      (document.getElementById('fileUploader') as HTMLInputElement).value = '';
      document.querySelector('.file-name').textContent = this.$t('upload');
      this.file = '';
    },
    clearTaskFile(): void {
      const elementId = `taskUploader_${this.task.id}`;
      (document.getElementById(elementId) as HTMLInputElement).value = '';
      document.querySelector(`.file-name${this.task.id}`).textContent = this.$t('upload');
      this.file = '';
      this.elementId = '';
    },
    clearPreEvaluationFile(): void {
      (document.getElementById('preEvaluationUploader') as HTMLInputElement).value = '';
      document.querySelector('.file-name').textContent = this.$t('upload');
      this.file = '';
      this.elementId = '';
    },
    clearPostEvaluationFile(): void {
      (document.getElementById('postEvaluationUploader') as HTMLInputElement).value = '';
      document.querySelector('.file-name').textContent = this.$t('upload');
      this.file = '';
      this.elementId = '';
    },
  },
};
